document.addEventListener("DOMContentLoaded", function () {
  // ===== 유틸 =====
  function qs(selector, ctx) {
    return (ctx || document).querySelector(selector);
  }

  function qsa(selector, ctx) {
    return Array.from((ctx || document).querySelectorAll(selector));
  }

  // 요소의 margin 포함 가로폭 계산
  function outerWidthWithMargin(el) {
    if (!el) return 0;
    const style = window.getComputedStyle(el);
    const ml = parseFloat(style.marginLeft) || 0;
    const mr = parseFloat(style.marginRight) || 0;
    return el.offsetWidth + ml + mr;
  }

  // 화면 폭에 따른 슬라이드 간격(spaceBetween) 계산
  function computeSpaceBetween(w) {
    if (w >= 990) {
      return Math.round(w * -0.2); // min 990
    }
    return Math.round(w * -0.4); // min 750
  }

  // 인디케이터 활성화 클래스 토글
  function indicatorActive(index) {
    qsa(".history_indicator a").forEach(function (a, i) {
      if (i === index) a.classList.add("active");
      else a.classList.remove("active");
    });
  }

  // 인디케이터 리스트를 현재 활성 항목이 가운데 오도록 이동
  function indicatorScrollTo(index) {
    const ol = qs(".history_indicator ol");
    if (!ol) return;
    const li = ol.children[index];
    const aActive = li ? li.querySelector("a") : null;
    if (!(li && aActive)) return;
    ol.style.transition = "margin-left 400ms ease";
    const target = -li.offsetLeft - aActive.offsetWidth / 2;
    ol.style.marginLeft = target + "px";
  }

  // 슬라이드 컬렉션/개수, 인디케이터 총폭, spaceBetween 초기값
  const slides = qsa(".history_slide .swiper-slide");
  const history_leng = slides.length;
  let indicator_width = 0;
  let spacePx = computeSpaceBetween(window.innerWidth);

  // Swiper 
  window.history_slide = new Swiper(".history_slide", {
    centeredSlides: true, 
    slidesPerView: 1, 
    spaceBetween: spacePx,
    speed: 800,
    initialSlide: 9, // 추가
    observer: true, 
    observeParents: true, 
    // mousewheel: { enabled: false },
    // breakpoints: {
    //   990: {
    //     mousewheel: { 
    //       enabled: true,
    //       releaseOnEdges: true,
    //     },
    //   },
    // },
    on: {
      init: function () {
        const ol = qs(".history_indicator ol");
        if (!ol) return;
        ol.innerHTML = "";
        indicator_width = 0;

        for (let i = 0; i < history_leng; i++) {
          const slide = slides[i];
          if (!slide) continue;

          const classes = (slide.className || "").split(" ");
          const second = classes[1] || "";
          let color_class =
            second.indexOf("logo1") >= 0 ? "ap_color" : "inni_color";
          if (i === 0) color_class += " active"; // 첫 항목 활성화

          // li > a > em(year) 구조 생성
          const li = document.createElement("li");
          const a = document.createElement("a");
          const em = document.createElement("em");
          a.href = "javascript:void(0);";
          a.className = color_class;

          // 슬라이드 내부 .year 텍스트를 인디케이터에 표시
          const yearEl = slide.querySelector(".year");
          em.textContent = yearEl ? (yearEl.textContent || "").trim() : "";

          a.appendChild(em);
          li.appendChild(a);
          ol.appendChild(li);

          // 인디케이터 클릭 시 해당 인덱스로 이동
          (function (index) {
            a.addEventListener("click", function (e) {
              e.preventDefault();
              if (
                window.history_slide &&
                typeof window.history_slide.slideTo === "function"
              ) {
                window.history_slide.slideTo(index);
              }
            });
          })(i);

          // 총 너비 누적(overflow 스크롤을 위해)
          indicator_width += outerWidthWithMargin(li);
        }
        ol.style.width = indicator_width + "px";

        // 인디케이터를 transition 없이 올바른 위치로 이동
        (function () {
          const swiper = window.history_slide;
          const ol = qs(".history_indicator ol");
          if (!swiper || !ol) return;
          const li = ol.children[swiper.activeIndex];
          const a = li && li.querySelector("a");
          if (li && a) {
            ol.style.transition = "none";
            const target = -li.offsetLeft - a.offsetWidth / 2;
            ol.style.marginLeft = target + "px";
          }
        })();

        // 배경/로고/인디케이터 클래스 동기화
        history_motion();
      },
      // 드래그 중, 전환 시작 시 상태 반영
      sliderMove: function () {
        history_motion();
      },
      transitionStart: function () {
        history_motion();
      },
      // 터치 종료 시 뷰 표시 클래스 제거
      touchEnd: function () {
        qsa(".swiper-slide").forEach(function (el) {
          el.classList.remove("swiper-slide-view");
        });
      },
    },

  });


  // 배경/로고/인디케이터/클래스 상태 동기화
  function history_motion() {
    const swiper = window.history_slide;
    if (!swiper) return;

    // max_w: 슬라이드 폭 + 간격, min_w: 그 절반
    const max_w = swiper.width + spacePx;
    const min_w = max_w / 2;
    // 현재 translate 기준으로 활성 인덱스 계산
    const check_active = Math.floor(((swiper.translate - min_w) / max_w) * -1);

    // 뷰 클래스 초기화
    qsa(".swiper-slide").forEach(function (el) {
      el.classList.remove("swiper-slide-view");
    });
    // Swiper 자체 activeIndex와 계산값이 다를 때 안전하게 active 클래스 제거
    if (swiper.activeIndex !== check_active) {
      qsa(".swiper-slide").forEach(function (el) {
        el.classList.remove("swiper-slide-active");
      });
    }

    // 활성화 된 슬라이드 표시
    const current = slides[check_active];
    if (!current) return;
    current.classList.add("swiper-slide-view");

    // 'bgType_logoType' 형태의 두 번째 클래스 분해
    const class_name = (current.className || "").split(" ")[1] || "";
    const bg_type = class_name.split("_")[0] || "";
    const logo_type = class_name.split("_")[1] || "";

    // 배경 전환: 기존 클래스 제거 후 해당 배경 클래스 추가
    qsa(".history_bg").forEach(function (bg) {
      bg.classList.remove("before_bg", "inni_bg", "ap_bg");
      if (bg_type) bg.classList.add(bg_type + "_bg");
    });

    // 로고 전환: 전부 숨기고 해당 타입만 표시
    qsa(".logo_type").forEach(function (el) {
      el.style.display = "none";
    });
    if (logo_type) {
      qsa("." + logo_type).forEach(function (el) {
        el.style.display = "block";
      });
    }

    // 인디케이터 활성화 및 스크롤 동기화
    indicatorActive(check_active);
    indicatorScrollTo(check_active);
  }


  // 리스트 항목 클릭 시 대응 슬라이드로 이동 
  document.addEventListener("click", function (e) {
    const anchor = e.target && e.target.closest("#history_list .list_con a");
    if (!anchor) return;

    e.preventDefault();
    const anchors = qsa("#history_list .list_con a");
    const index = anchors.indexOf(anchor);
    if (
      index > -1 &&
      window.history_slide &&
      typeof window.history_slide.slideTo === "function"
    ) {
      window.history_slide.slideTo(index);
    }
    history_list_close();
  });

  // 리스트 열기
  window.history_list_open = function () {
    const el = document.getElementById("history_list");
    if (!el) return;
    el.style.display = "block";
    el.style.opacity = "0";
    el.style.transition = "opacity 400ms ease";
    void el.offsetHeight; 
    el.style.opacity = "1";
    document.documentElement.style.overflow = "hidden";
  };

  // 리스트 닫기
  window.history_list_close = function () {
    const el = document.getElementById("history_list");
    if (!el) return;
    el.style.transition = "opacity 400ms ease";
    el.style.opacity = "0";
    const onEnd = function () {
      el.style.display = "none";
      el.removeEventListener("transitionend", onEnd);
    };
    el.addEventListener("transitionend", onEnd);
    document.documentElement.style.overflow = "auto";
  };

  // 리스트 탑버튼 클릭 시 최상단으로 스크롤
  window.history_list_top = function () {
    const el = document.getElementById("history_list");
    if (!el) return;
    el.scrollTo({ top: 0, behavior: "smooth" });
  };

  function updateSpaceBetween() {
    const swiper = window.history_slide;
    if (!swiper) return;
    const next = computeSpaceBetween(window.innerWidth);
    if (next !== spacePx) {
      spacePx = next;
      swiper.params.spaceBetween = spacePx;
    }
    swiper.update();

    // 인디케이터 폭/위치 재계산
    const ol = qs(".history_indicator ol");
    if (ol) {
      let total = 0;
      qsa(".history_indicator ol > li").forEach(function (li) {
        total += outerWidthWithMargin(li);
      });
      indicator_width = total;
      ol.style.width = total + "px";
      indicatorScrollTo(
        typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0
      );
    }

    // 배경/로고/활성 상태 동기화
    history_motion();
  }
  
  // 성능을 위해 디바운스(150ms)
  let resizeTimer = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSpaceBetween, 150);
  });

  window.addEventListener("load", updateSpaceBetween);
});
